/**
 * vapor-chamber-router — blade rows as ordinary components.
 *
 * A blade record's fetched HTML is wrapped into a throwaway component whose
 * lifecycle owns the swap: mounted → innerHTML + hydrate(el); before unmount
 * → dehydrate(el) + clear. The outlet renders it like any other component.
 * Hooks are the app's island conventions, injected via router options.
 */

import { defineComponent, h, onBeforeUnmount, onMounted, ref } from 'vue';

export type BladeHooks = {
  hydrate?: (el: Element) => unknown;
  dehydrate?: (el: Element) => unknown;
};

export function makeBladeComponent(html: string, hooks: BladeHooks) {
  return defineComponent({
    name: 'VcrBlade',
    setup() {
      const el = ref<HTMLElement | null>(null);
      onMounted(() => {
        if (!el.value) return;
        el.value.innerHTML = html;
        hooks.hydrate?.(el.value);
      });
      onBeforeUnmount(() => {
        if (!el.value) return;
        hooks.dehydrate?.(el.value);
        el.value.innerHTML = '';
      });
      return () => h('div', { 'data-vcr-blade': '', ref: el });
    },
  });
}
